<template>
  <b-dropdown
    :ref="dropdownRef"
    menu-class="w-100"
    variant="outline-primary"
    :text="dropdownHint"
    @hide="handleHide($event)"
    @hidden="isCloseable = false"
  >
    <div class="ml-2 mr-2">
      Date
      <b-form-datepicker
        v-model="datePicker"
        reset-button
        close-button
        placeholder="Select a date"
        size="sm"
        locale="en"
        class="mb-3"
      ></b-form-datepicker>
      Time
      <b-form-timepicker
        v-model="timePicker"
        reset-button
        placeholder="Select a time"
        size="sm"
        locale="en"
        class="mb-3"
      ></b-form-timepicker>
      <b-button variant="outline-danger" size="sm" @click="closeMe()"
        >Close</b-button
      >
    </div>
  </b-dropdown>
</template>

<script>
export default {
  name: 'DateTimePicker',
  props: {
    dropdownRef: {
      type: String,
      required: true
    },
    dropdownText: {
      type: String,
      required: true
    },
    datePickerValue: {
      type: String,
      required: false
    },
    timePickerValue: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      isCloseable: false,
      datePicker: '',
      timePicker: ''
    };
  },

  computed: {
    dropdownHint() {
      if (this.timePicker == '' && this.datePicker == '') {
        return this.dropdownText;
      } else if (this.timePicker == '') {
        return `${this.datePicker}`;
      } else {
        return `${this.datePicker} - ${this.timePicker}`;
      }
    }
  },

  methods: {
    handleHide(bvEvent) {
      if (!this.isCloseable) {
        bvEvent.preventDefault();
      } else {
        this.$refs[this.dropdownRef].hide();
      }
    },

    closeMe() {
      this.isCloseable = true;
      this.$refs[this.dropdownRef].hide();
    }
  },

  watch: {
    datePicker() {
      if (this.datePicker == '') {
        this.timePicker = '';
      } else {
        this.timePicker = '00:00:00';
      }
      this.$emit('update-date', this.datePicker);
    },
    timePicker() {
      this.$emit('update-time', this.timePicker);
    },
    datePickerValue() {
      this.datePicker = this.datePickerValue;
    },
    timePickerValue() {
      this.timePicker = this.timePickerValue;
    }
  }
};
</script>
